export default __webpack_public_path__ + "static/media/aglio.a38677db.png";